<template>
  <div class="block-wrap block-specification" style="padding: 10px" v-loading="!hasReRender">
    <template v-if="hasReRender">
      <div v-for="(s, sindex) in specifications" :key="sindex">
        <div class="title-bg">
          规格名：
          <el-select
            v-model="s.name"
            @change="e => specNameChange(sindex, e)"
            filterable
            placeholder="请选择规格名"
            style="width: 160px"
          >
            <el-option
              v-for="(item, idx) in specNameOptions"
              :key="idx"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            v-if="remarkKey && s.valueItemRule.supportRemark"
            style="float: right; margin-right: 8px"
            type="link"
            @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
        </div>
        <div class="specification-value">
          <div style="display: inline-block; padding-top: 7px; padding-left: 10px; vertical-align: top">规格值：</div>
          <div class="specification-value-flex">
            <vue-draggable v-model="specifications[sindex].values" :group="{ name: s.name, pull: 'clone', put: false }" :animation="500">
              <template v-for="(v, vi) in specifications[sindex].values">
                <div class="spec-value-item" :key="vi">
                  <el-form ref="specValueForm" :key="vi" :model="v" inline>
                    <div :key="vi" class="specification-value-flex_item" v-if="s.valueItemRule">
                      <el-form-item prop="value" :rules="genFormItemRule(v, s,vi)">
                        <div class="del-input-wrap">
                          <template v-if="s.valueItemRule.attrValueList">
                            <el-select
                              :ref="`${sindex}-${vi}`"
                              placeholder="请选择"
                              v-model="v.value"
                              filterable
                              style="width: 160px"
                              allow-create
                              blur-create
                              @change="e => handleValueChange(v)"
                            >
                              <template v-for="(op, selectIndex) in s.valueItemRule.attrValueList">
                                <el-option
                                  :key="selectIndex"
                                  :label="op.name"
                                  :value="op.name"
                                  :disabled="s.values.findIndex(_v => _v.value === op.name) > -1"
                                />
                              </template>
                            </el-select>
                          </template>
                          <template v-else>
                            <el-input
                              :ref="`${sindex}-${vi}`"
                              :disabled="isPureType"
                              placeholder="请输入"
                              readonly
                              @focus="e => focusHandle(sindex, vi, v)"
                              class="specification-value-flex_input"
                              v-model="v.value"
                            />
                          </template>
                          <el-checkbox
                            style="margin-left: 8px"
                            v-model="v.checked"
                            @change="onChangeCheckbox"
                            :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"
                          ></el-checkbox>
                          <!-- <span class="drag-icon-wrap">
                            <el-tooltip class="item" effect="dark" content="长按拖拽排序" placement="top">
                              <span class="el-icon-Group-50 drag-icon"></span>
                            </el-tooltip>
                          </span> -->
                          <drag-item-content />
                        </div>
                      </el-form-item>
                      <div v-if="remarkKey && s.valueItemRule.supportRemark" class="remarkWrap">
                        <el-input
                          class="input-remark"
                          :ref="`${sindex}-${vi}-remark`"
                          placeholder="规格备注"
                          :disabled="isPureType"
                          @input="remarkInput"
                          v-model="v[remarkKey]"
                          maxlength="18"
                        ></el-input>
                      </div>
                      <div v-if="sindex === 0" class="specification-value-flex_img">
                        <ImgUpload
                          :width="80"
                          :height="80"
                          :file="v.imageUrl"
                          :ref="`images_${v.propValueId}`"
                          @upload-success="url => imageUploadSuccess(url, v)"
                          @del="() => imageUploadDel(v)"
                          :limitSuffix="imgLimitSuffix"
                          :isSingle="true"
                          :isPureType="isPureType"
                          :aspectRatio="[1]"
                          aspectRatioText='1:1'
                          :isCheckImg="isCheckImg"
                          :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                        />
                      </div>
                    </div>
                  </el-form>
                </div>
              </template>
            </vue-draggable>
            <div class="tips ft-12">
              <span>默认取商品第一张主图，买家选择不同规格会看到对应规格图片，建议尺寸：800 x 800像素，建议格式：png，jpg，jpeg格式</span>
            </div>
            <div v-if="!specifications[sindex].values || specifications[sindex].values.length === 0" class="tips ft-12">
              <span style="color: red">请先去基础资料里维护对应的规格</span>
            </div>
            <!-- <div v-if="!isPlatform" class="specification-value-flex_item">
              <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="unrenderSpecList && unrenderSpecList.length > 0" class="add-sku-tips">
        <div>
          <span>您还可以维护规格</span>
          <template v-for="(item, index) in unrenderSpecList">
            <span :key="index"> 「{{ item.valueRules.title || item.valueRules.name }}」 </span>
          </template>
          <span>，</span>
          <template v-if="unrenderRequiredSpecList.length > 0">
            <span>其中规格</span>
            <template v-for="(item, index) in unrenderRequiredSpecList">
              <span :key="index" style="color: red"> 「{{ item.valueRules.title || item.valueRules.name }}」 </span>
            </template>
            <span>平台要求为必填，为避免铺货失败</span> </template
          ><span>请至</span><el-link @click="changeToBase">【基础资料】</el-link><span>进行添加</span>
        </div>
      </div>
      <div v-else-if="needlessSpecList && needlessSpecList.length > 0" class="add-sku-tips">
        <div>
          <span>平台不支持规格</span>
          <template v-for="(item, index) in needlessSpecList">
            <span :key="index" style="color: red"> 「{{ item.name }}」 </span>
          </template>
          <span>，请至</span><el-link @click="changeToBase">【基础资料】</el-link><span>进行删除</span>
        </div>
      </div>
    </template>
    <DialogSpecModel ref="dialogSpecModel" :checkValueItemCrossFunc="handleCheckValueItemCrossFunc" @on-success="handleSelectCallback" />
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue';
import { cloneDeep } from 'lodash';
import DialogSpecModel from './DialogSpecModel/Index.vue';
import { dragItemMixin } from '../../utils/mixins';
import { getBytesCount } from "@utils/data"
import { formatSpecValues } from './service';

export default {
  inject: {
    isGroupPuhuo: {
      default: false,
    },
    disabledSpName: {
      default: false,
    },
    noSpPic: {
      default: false,
    },
  },
  components: {
    ImgUpload,
    DialogSpecModel,
    BatchSetSpecRemarksDialog,
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    // 未渲染的规格列表
    unrenderSpecList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 不需要渲染的规格
    needlessSpecList: {
      type: Array,
      default() {
        return [];
      },
    },
    changeToBase: {
      // 打开基础资料编辑
      type: Function,
      default: () => {},
    },
    imgLimitSuffix: {
      // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif',
    },
    remarkKey: {
      type: String,
      default: '',
    },
    pureType: {
      type: Number,
      default: 0,
    },
    isCheckImg: {
      type: Boolean,
      default: true,
    },
    allSaleProps: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      specifications: [],
      showAddSkuTips: true,
      specOptions: [], // 规格名下拉框列表项
      selectLoading: false, // 规格名下拉框loading
      isPureType: false,
      hasReRender: true,
      operateSpecIndex: 0,
      operateSpecValueIndex: 0,
    };
  },
  computed: {
    unrenderRequiredSpecList() {
      const filterList = this.unrenderSpecList.filter(item => {
        return item.isRequired === true;
      });
      return filterList;
    },
    specNameOptions() {
      return this.allSaleProps.map(item => {
        const { valueRules = {} } = item;
        return {
          label: valueRules.title || valueRules.name,
          value: valueRules.title || valueRules.name,
          raw: item,
        };
      });
    },
  },
  watch: {
    values: {
      handler(v) {
        this.specifications = v;
        this.$forceUpdate();
      },
      immediate: true,
    },
    pureType: {
      handler(val) {
        this.isPureType = val === 0 ? false : true;
      },
      immediate: true,
    },
  },
  mounted() {
    const noTips = localStorage.getItem('noSecTips');
    if (noTips === '1') {
      this.showAddSkuTips = false;
    }
  },
  methods: {
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        remarkKey: this.remarkKey,
        specifications: this.specifications,
        sureFn: (specs) => {
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    // 刷新组件重新渲染
    reRenderPage() {
      this.hasReRender = false;
      setTimeout(() => {
        this.hasReRender = true;
      }, 300);
    },
    validateExtendValues(extendValue, items) {
      return !items.some(ruleItem => {
        const { required, properties,features } = ruleItem;
        if (!required) return false;
        const formValue = extendValue[properties.id.enum[0]];
        if (!formValue) return true;

        // 针对京东平台规则优化改造,如果valueId没有值，校验不通过
        if(features?.isLocked == 1){
          if (!formValue.valueId) return true;
          // const preprocessingSaleAttrValTemplateValueList = properties.value?.enum?.[0]?.preprocessingSaleAttrValTemplateValueList
          // if(preprocessingSaleAttrValTemplateValueList?.length) {

          // }
        }

        return required.some(key => !formValue[key]);
      });
    },
    genFormItemRule(valueItem, specItem,vi) {
      const { valueItemRule = {}} = specItem;
      const { valueDisplayStyle, attrValueList = [], items = [] } = valueItemRule;
     
      // 京东新版数据结构的校验
      let valueValidator = async (rule, value, callback) => {
        try {
          // 如果未勾选，跳过校验
          if (!valueItem.checked) return callback();

          // 必填与长度（对字符串去除首尾空格后判断）
          const valStr = typeof valueItem.value === 'string' ? valueItem.value.trim() : valueItem.value;
          if (!valStr) return callback(new Error('请填写规格值'));
          if (typeof valStr === 'string' && getBytesCount(value) > 50) return callback(new Error('规格值不能大于【50字符】'));

          // 重复值检查（仅对已勾选项）
          if (value) {
            const normalized = typeof value === 'string' ? value.trim() : value;
            const findItem = specItem.values.find((item, i) => {
              const itemVal = typeof item.value === 'string' ? item.value.trim() : item.value;
              return item.checked && itemVal == normalized && i !== vi;
            });
            if (findItem) return callback(new Error('请勿输入相同规格值'));
          }

          // 扩展字段校验（京东新版结构）
          if (!attrValueList?.length && items.length > 0) {
            const extendValuesValidSize = this.validateExtendValues(valueItem.extendValues, items);
            if (!extendValuesValidSize) return callback(new Error('请按平台要求填写规格值'));
          }

          // 图片校验
          const imgRef = `images_${valueItem.propValueId}`;
          if (valueItem.imageUrl && (this.$refs[imgRef] && this.$refs[imgRef][0])) {
            const errMsg = await this.$refs[imgRef][0].method_validImage();
            if (errMsg) return callback(new Error('规格图:'+errMsg));
          }

          return callback();
        } catch (e) {
          return callback(new Error(e?.message || '校验异常，请重试'));
        }
      }
      // 度量衡的校验规则
      // if (attrValueList && attrValueList.length > 0) {
      //   valueValidator = (rule, value, callback) => {
      //     if (!valueItem.value) {
      //       return callback(new Error('请填写规格值'))
      //     }
      //     const hasMatchValue = attrValueList.some(item => {
      //       return item.name === valueItem.value;
      //     });
      //     if (!hasMatchValue) {
      //       return callback(new Error('规格值匹配失败，请重新选择'))
      //     }
      //     callback();
      //   }
      // }
      return [
        { required: valueItem.checked, message: '规格值必填', trigger: ['change', 'blur'] },
        { validator: valueValidator, trigger: ['change', 'blur'] },
      ];
    },
    validateSpecValueForm() {
      const valueForms = this.$refs.specValueForm;
      return new Promise(resolve => {
        // resolve(true);
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            const allValid = results.every(result => {
              return result === true;
            });
            resolve(allValid);
          })
          .catch(() => {
            console.log('validateSpecValueForm has Error');
            resolve(false);
          });
      });
    },
    fieldChanged() {
      this.$emit('fieldChanged');
    },
    // 属性备注输入事件
    remarkInput() {
      this.$set(s, 'isEdited', true)
      window.__spcificationRemark_changed = true; // 用于skuList生成时的图片取值规则
    },
    // 规格名回车事件
    nameEnter(sindex) {
      let firstInputVm = this.$refs[`${sindex}-0`]; // 当前规格下的第一个规格值输入框
      firstInputVm = firstInputVm ? firstInputVm[0] : firstInputVm;
      if (!firstInputVm) {
        return false;
      } else {
        // 聚焦到第一个
        firstInputVm.focus();
      }
    },
    nameChange(s) {
      // this.$set(s, 'isEdited', true)
      this.fieldChanged()
    },
    // 规格名下拉框 change 事件
    specNameChange(sindex, newName) {
      const currentSpec = this.specifications[sindex];
      // 查找是否有其他规格使用了相同的名字
      const matchIndex = this.specifications.findIndex((item, idx) => {
        return idx !== sindex && item.name === newName;
      });
      if (matchIndex > -1) {
        // 找到重名规格，交换两个规格的完整数据
        const matchSpec = this.specifications[matchIndex];
        const swapFields = ['name', 'values', 'valueItemRule', 'id', 'nameKey', 'valueKey'];
        const currentData = {};
        const matchData = {};
        swapFields.forEach(field => {
          currentData[field] = currentSpec[field];
          matchData[field] = matchSpec[field];
        });
        // 互相赋值（交换）
        swapFields.forEach(field => {
          this.$set(currentSpec, field, matchData[field]);
          this.$set(matchSpec, field, currentData[field]);
        });
      } else {
        // 选择了一个新的规格名（来自 unrenderSpecList 或未使用的规格）
        // 需要生成新的渲染规则，并把旧的规格值填在新的渲染规则内
        const matchedAllSaleProp = this.allSaleProps.find(item => {
          const { valueRules = {} } = item;
          return (valueRules.title || valueRules.name) === newName;
        });
        if (matchedAllSaleProp) {
          const { valueRules } = matchedAllSaleProp;
          const valueItemRule = { ...valueRules };
          if (!valueItemRule.id) {
            valueItemRule.id = matchedAllSaleProp.attrId;
          }
          // 参考 service.js 中 formatSpecValues 的逻辑：保留原有值的 value/checked/imageUrl 等字段，重新构建 extendValues
          const oldValues = cloneDeep(currentSpec.values);
          currentSpec.values = formatSpecValues(oldValues, { valueRules: valueItemRule });
          // 更新规格的其他属性
          this.$set(currentSpec, 'valueItemRule', valueItemRule);
          this.$set(currentSpec, 'id', valueRules.attrId || valueRules.id);
          // 如果之前没有 nameKey/valueKey，补充上
          if (!currentSpec.nameKey) {
            this.$set(currentSpec, 'nameKey', matchedAllSaleProp.nameKey || '');
          }
          if (!currentSpec.valueKey) {
            this.$set(currentSpec, 'valueKey', matchedAllSaleProp.valueKey || '');
          }
          // 通知父组件更新 unrenderSpecList 和 imagesMap
          this.$emit('specNameChanged');
        }
      }
      this.fieldChanged();
    },
    handleValueChange(v) {
      // this.$set(v, 'isEdited', true)
      this.fieldChanged()
    },
    focusHandle(sindex, vi, v) {
      // this.$set(v, 'isEdited', true)
      const specItem = this.specifications[sindex];
      const { extendValues, value } = specItem.values[vi];
      const { valueItemRule } = specItem;
      this.operateSpecIndex = sindex;
      this.operateSpecValueIndex = vi;
      this.$refs.dialogSpecModel.handleShow(extendValues, valueItemRule, value);
    },
    handleSelectCallback({ extendValues, ruleUnValidTips }) {
      const specItem = this.specifications[this.operateSpecIndex];
      if (ruleUnValidTips) {
        this.$confirm(ruleUnValidTips, '提示')
          .then(() => {
            // 清空其它valueItem的extendValue
            specItem.values.forEach(item => {
              const hasFirstTempId = Object.keys(item.extendValues).some(key => {
                return item.extendValues[key].firstTempId;
              });
              if (hasFirstTempId) {
                Object.keys(item.extendValues).forEach(key => {
                  if (item.extendValues[key].firstTempId) {
                    Object.assign(item.extendValues[key], {
                      firstTempId: '',
                      valueId: '',
                      value: '',
                    });
                  } else {
                    Object.assign(item.extendValues[key], {
                      valueId: '',
                      value: '',
                    });
                  }
                });
                item.value = '';
              }
            });
            this.handleUpdateExtendValue(extendValues);
          })
          .catch(() => {});
        return false;
      }
      this.handleUpdateExtendValue(extendValues);
    },
    handleUpdateExtendValue(extendValues) {
      const specItem = this.specifications[this.operateSpecIndex];
      const { items = [] } = specItem.valueItemRule;
      const newValue = [];
      items.forEach(element => {
        const matchItem = extendValues[`${element.properties.id.enum[0]}`];
        if (matchItem && matchItem.value) {
          newValue.push(`${matchItem.value}${matchItem.unit || ''}`);
        }
      });
      Object.assign(specItem.values[this.operateSpecValueIndex], {
        extendValues,
        value: newValue.join(''),
      });
      // 程序更新值后定点触发当前项校验
      this.$nextTick(() => {
        const forms = this.$refs.specValueForm;
        const curForm = Array.isArray(forms) ? forms[this.operateSpecValueIndex] : forms;
        if (curForm && curForm.validateField) {
          curForm.validateField('value');
        }
      });
    },
    handleCheckValueItemCrossFunc(modelId, firstTempId, templateList) {
      const specItem = this.specifications[this.operateSpecIndex];
      const isValid = specItem.values.find(item => {
        const extendValue = item.extendValues ? item.extendValues[modelId] : null;
        if (extendValue && extendValue.firstTempId) {
          if (extendValue.firstTempId !== firstTempId) {
            return item;
          }
        }
        return null;
      });
      if (isValid) {
        return isValid.extendValues[modelId];
      }
      return true;
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      if (this.isPureType) return;
      const _copy = [].concat(this.specifications[sindex].values);
      _copy.splice(index, 1);
      this.specifications[sindex].values = _copy;
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    onChangeCheckbox() {
      // this.$set(v, 'isEdited', true)
      window.__spcificationCheckbox_changed = true;
    },
    imageUploadSuccess(url, v) {
      // this.$set(v, 'isEdited', true)
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', v);
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v) {
      // this.$set(v, 'isEdited', true)
      v.imageUrl = '';
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', v);
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    changeSelectSpecName() {
      window.__spcificationCheckbox_changed = true;
      this.fieldChanged();
    },
    handleCascaderValueChange({ label, value, showValue, cpvPathList }, specValueItem) {
      specValueItem.value = label;
      specValueItem.fxgExtra.valueId = value;
      specValueItem.fxgExtra.showValue = showValue;
      specValueItem.fxgExtra.cpvPathList = cpvPathList;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      window.__spcificationCheckbox_changed = specValueItem.valueKey;
      this.fieldChanged();
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  line-height: 24px !important;
}
.block-wrap {
  border: 1px solid #dcdfe6;

  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    padding-top: 7px;
    &_item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &_img {
      width: 82px;
      height: 82px;
      margin-top: 10px;
      position: relative;
    }
    .el-input {
      width: 160px;
    }
  }
}
.del-input-wrap {
  position: relative;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
.spec-value-item {
  display: inline-block;
}
::v-deep .el-form-item__error {
  position: relative;
}
</style>
